import { Card, Stack, Text } from '@mantine/core';
import type { Example } from './types';

type ExampleStackProps = {
  examples: Example[];
};

export function ExampleStack({ examples }: ExampleStackProps) {
  return (
    <Stack gap="xl">
      {examples.map(example => (
        <Stack key={example.description} gap="xs">
          <Text size="sm" c="dimmed">
            {example.description}
          </Text>
          <Card withBorder padding="md">
            {example.render}
          </Card>
        </Stack>
      ))}
    </Stack>
  );
}
